import { apiUrl } from "../utils/api";

/**
 * Vorgänge aus den VO/VE-Ordnern einer alten Kundenakte (Plan 01.10.2026, C).
 * Spiegel von `apps/api/src/kundenakten-vorgang.service.ts`.
 */
export type KundenaktenVorgangStatus = "gewuenscht" | "offen" | "angelegt" | "verworfen" | "fehler";

export type KundenaktenVorgangEintrag = {
  id: number;
  relPfad: string;
  name: string;
  status: KundenaktenVorgangStatus;
  grund: string | null;
  titel: string | null;
  jahr: number | null;
  vorgangStatus: "Offen" | "Erledigt" | null;
  vorgangId: number | null;
  dokumente: number;
};

export type VorgangEntscheidung = {
  relPfad: string;
  anlegen: boolean;
  titel?: string | null;
  status?: "Offen" | "Erledigt" | null;
  jahr?: number | null;
};

export const kundenaktenVorgangService = {
  async liste(folderId: number): Promise<{ contactId: number | null; eintraege: KundenaktenVorgangEintrag[] }> {
    const res = await fetch(apiUrl(`kundenakten-folders/${folderId}/vorgaenge`));
    if (!res.ok) throw new Error(`Vorgänge konnten nicht geladen werden (HTTP ${res.status})`);
    const data = await res.json();
    return { contactId: data?.contactId ?? null, eintraege: Array.isArray(data?.eintraege) ? data.eintraege : [] };
  },

  async entscheiden(folderId: number, eintraege: VorgangEntscheidung[]): Promise<KundenaktenVorgangEintrag[]> {
    const res = await fetch(apiUrl(`kundenakten-folders/${folderId}/vorgaenge`), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ eintraege }),
    });
    if (!res.ok) throw new Error(`Entscheidung konnte nicht gespeichert werden (HTTP ${res.status})`);
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  },
};

/** Was der Nutzer noch entscheiden muss: nicht deutbare Ordner. */
export const zuEntscheiden = (eintraege: KundenaktenVorgangEintrag[]): KundenaktenVorgangEintrag[] =>
  eintraege.filter((e) => e.status === "offen");
